<template>
  <details v-if="hasVoteCandidateBody(safeHtml) || details.videos.length" class="vote-candidate-details" @toggle="onToggle">
    <summary :aria-label="`${candidateName}，查看详情`">查看详情</summary>
    <section v-if="opened" class="candidate-detail-content" :aria-label="`${candidateName}的介绍与视频`">
      <div v-if="safeHtml" class="candidate-detail-html"><div v-html="safeHtml" /></div>
      <article v-for="(video, index) in details.videos" :key="`${video.videoUrl}:${index}`" class="candidate-detail-video">
        <h3>{{ video.title || video.videoName }}</h3>
        <p v-if="video.subTitle">{{ video.subTitle }}</p>
        <video v-if="video.videoUrl && !failed.has(index)" :src="video.videoUrl" :poster="video.videoCoverUrl || undefined"
          :aria-label="video.title || video.videoName" controls playsinline preload="none" @error="failed.add(index)" />
        <p v-else role="status">{{ video.videoUrl ? '视频暂时无法播放，请稍后重试' : '视频地址无效，请联系客服' }}</p>
      </article>
    </section>
  </details>
</template>
<script setup>
import { computed, ref } from 'vue';
import { hasVoteCandidateBody } from '../../services/activities/voteCandidateDetails.mjs';
import { sanitizeRichText } from '../../services/activities/richText.js';
const props = defineProps({ details: { type: Object, required: true }, candidateName: { type: String, required: true } });
const safeHtml = computed(() => sanitizeRichText(props.details.html));
const opened = ref(false), failed = ref(new Set());
// Closing removes the media element, so background playback cannot continue.
function onToggle(event) { opened.value = Boolean(event.currentTarget.open); if (opened.value) failed.value = new Set(); }
</script>

<style scoped>
.vote-candidate-details { grid-column:1 / -1; box-sizing:border-box; width:100%; min-width:0; margin-top:8px; color:var(--act-text,#303442); text-align:left; font-size:13px; line-height:1.7; overflow-wrap:anywhere; }
.vote-candidate-details summary { min-height:44px; padding:10px 0; box-sizing:border-box; cursor:pointer; color:var(--vote-ink,#0878cc); font-weight:500; }
.vote-candidate-details summary:focus-visible { outline:2px solid var(--vote-ink,#0878cc); outline-offset:2px; }
.candidate-detail-content { min-width:0; padding:8px 0; border-top:1px solid var(--act-line,#e4e6ed); }
.candidate-detail-html { min-width:0; overflow-x:auto; }
.candidate-detail-html :deep(img),.candidate-detail-html :deep(video) { max-width:100%; height:auto; }
.candidate-detail-html :deep(table) { max-width:100%; border-collapse:collapse; }
.candidate-detail-video { min-width:0; margin-top:16px; }
.candidate-detail-video:first-child { margin-top:0; }
.candidate-detail-video h3 { margin:0 0 6px; font:inherit; font-weight:600; }
.candidate-detail-video p { margin:0 0 8px; color:var(--act-secondary,#616783); }
.candidate-detail-video video { display:block; width:100%; height:auto; aspect-ratio:16 / 9; background:#000; object-fit:contain; }
</style>
